import React from "react";
import SkeletonElement from "./SkeletonElement";

export default function SkeletonArticle() {
  return (
      <div className="h-[300px] skeletonWrapper rounded-2xl p-5 animate-pulse">
        <SkeletonElement type="title" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
      </div>
  );
}
